export const AUTH_MESSAGES = {
  LOGIN_FAILED: 'Такой учетной записи не существует или пароль неверный',
  INCORRECT_2FA_CODE: 'Вы ввели неверный код',
};
